import eventbus from 'gia/eventbus';
import Component from 'gia/Component'
import gsap from 'gsap'
import _each from 'lodash.foreach'


class Loader extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element


    this.ref =  {
      text: null,
      logo: null
    }

  }

  mount() {

    this.menu = document.getElementById('menu')

    var tl = gsap.timeline();

     tl.to (this.ref.logo, {alpha: 0, ease: "power4.out", duration: 2.5}, 1)
     tl.to (this.ref.text, {alpha: 1, ease: "power4.out", duration: 1}, 2)
     tl.to (this.ref.text, {alpha: 1, duration: 2, onComplete: this.complete.bind(this)}, 2.5)

  }


  complete() {
      gsap.to (this.element, {yPercent: -100 , force3D:true, ease: "power4.inOut", duration: 2, onComplete: this.start.bind(this)})
      gsap.to (this.menu, {yPercent: -100 , force3D:true, ease: "power4.inOut", duration: 2})
      gsap.fromTo('.intro', {yPercent: 100 , force3D:true, ease: "power4.inOut", duration: 2}, {yPercent: 0 , force3D:true, ease: "power4.inOut", duration: 2})
  }

  start() {
      eventbus.emit("startBlur");
      this.body.addClass('loaded')
  }

  unmount() {

  }


}

module.exports = Loader
